import { useCallback, useState } from 'react'

/** useState that survives a reload. Falls back silently if storage is unavailable. */
export function useStickyState<T>(key: string, initial: T, isValid: (v: unknown) => v is T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = window.localStorage.getItem(key)
      if (stored === null) return initial
      const parsed = JSON.parse(stored)
      return isValid(parsed) ? parsed : initial
    } catch {
      return initial
    }
  })

  const update = useCallback(
    (next: T) => {
      setValue(next)
      try {
        window.localStorage.setItem(key, JSON.stringify(next))
      } catch {
        /* private browsing or storage full — the app still works, just forgetfully */
      }
    },
    [key],
  )

  return [value, update] as const
}
